module.exports = __webpack_public_path__ + "media/images/countryrect/flanders-48b92efd6d2331a445201f08486a1dfb.svg";